export const BASE_URL = 'https://garagedoorrepairofflorida.com';
export const COMPANY_NAME = 'Garage Door Repair of Florida';
export const COMPANY_ABBREVIATION = 'GDR';
// Mail is intentionally still sent from the garagedoorrepairllc.com domain:
// it holds the configured SPF/DKIM records. Display name only lives in COMPANY_NAME.
export const COMPANY_DOMAIN = 'garagedoorrepairllc.com';
export const COMPANY_EMAIL = 'contactus@garagedoorrepairllc.com';
export const COMPANY_PHONE = '(407) 375-7969';
// Where the business is physically based (matches siteSettings.physicalAddress in Sanity).
export const LOCATION_CITY_STATE = 'Sanford, Florida';
// Regional umbrella used in body copy and page metadata.
export const SERVICE_REGION = 'Central Florida';
// The full tri-county footprint, used where the service area is stated explicitly.
export const SERVICE_COUNTIES = 'Seminole, Orange, and Volusia counties';
// Machine-readable form of the same footprint, for schema.org areaServed.
export const SERVICE_COUNTY_NAMES = ['Seminole County', 'Orange County', 'Volusia County'];
